import React, {Component} from "react"
import {Container, Header, Loader, Segment, Table} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {getLocalization} from "../utils/localization";
import {connect} from "react-redux";
import {setPrevRoute} from "../actions/appHeaderActions";
import {checkIsOpenEnrollment, checkIsVerified, formatMoneyAmount, getEnrollmentTimezone, getStepProps, getTranslatedCoverageText, isAIG, isAnsel, isRenaissance, uiFlowStandalone, getTierName, hasTierSelected} from "../utils/common";
import Steps from "./steps/steps";
import 'rc-slider/assets/index.css';
import Footer from "./footer";
import moment from "moment";
import 'moment-timezone';
import {getChronicRiderLabel, getMaternityRiderLabel, getMentalRiderLabel} from "../utils/riders";
import {ClickableText, CustomGrid} from "./custom-common";
import PlanWarningsBanner from "./planWarningsBanner";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;
    const {openEnrollment, riderLabels} = initialData;

    const { contractTerms } = initialData?.ratedClass || {};

    const additionalChronic = contractTerms?.chronicBrokerRequested ? contractTerms.chronicCoverageLimit : 0;
    const additionalMental = contractTerms?.mentalBrokerRequested ? contractTerms.mentalCoverageLimit : 0;
    const additionalMaternity = contractTerms?.maternityBrokerRequested ? contractTerms.maternityCoverageLimit : 0;

    const isBrellaChoice = !!initialData && !!initialData.contractInfo && initialData.contractInfo.planOffering === "Brella Choice";

    const {enrollmentStartDate, enrollmentEndDate} = openEnrollment;
    const start = moment(enrollmentStartDate);
    const end = moment(enrollmentEndDate);
    const isOpenEnrollment = checkIsOpenEnrollment(start, end, getEnrollmentTimezone(initialData));

    return {
        ...ownProps,
        additionalChronic,
        additionalMental,
        additionalMaternity,
        isBrellaChoice,
        user,
        initialData,
        isOpenEnrollment,
        benAdmin,
        moderateIncrements: (!!initialData && !!initialData.increments && initialData.increments.moderate) || [],
        severeIncrements: (!!initialData && !!initialData.increments && initialData.increments.severe) || [],
        catastrophicIncrements: (!!initialData && !!initialData.increments && initialData.increments.catastrophic) || [],
        moderateCoverageSelected: user.moderateCoverageSelected,
        severeCoverageSelected: user.severeCoverageSelected,
        catastrophicCoverageSelected: user.catastrophicCoverageSelected,
        tiers: user.selectedTierBrellaSelect,
        lang: user.lang,
        employerContribution: user.employerContribution,
        cost: user.cost,
        costPerOptions: initialData.costPerOptions,
        costPerOption: user.costPerOption,
        coverageOptions: initialData.coverageOptions,
        coverageOption: user.coverageOption,
        effectiveDate: initialData.coverageEffectiveDate,
        riderLabels,
    }
};

class Summary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepProps: null,
        };
    }

    async componentDidMount() {
        const {initialData, user, benAdmin} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props);
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
        this.buildSteps();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lang !== this.props.lang) {
            this.buildSteps();
        }
    }

    buildSteps = () => {
        const {initialData: {uiFlow, distributionChannel}, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 2, uiFlow, distributionChannel)});
    }

    translateSliderSelectionToAmount = () => {
        const {moderateIncrements, severeIncrements, catastrophicIncrements, moderateCoverageSelected, severeCoverageSelected, catastrophicCoverageSelected} = this.props;
        return {
            moderateCoverageSelected: moderateIncrements[moderateCoverageSelected-1],
            severeCoverageSelected: severeIncrements[severeCoverageSelected-1],
            catastrophicCoverageSelected: catastrophicIncrements[catastrophicCoverageSelected-1],
        }
    }

    render() {
        const {stepProps,} = this.state;
        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }

        const {
            lang, moderateCoverageSelected, severeCoverageSelected, catastrophicCoverageSelected, isBrellaChoice, coverageOptions, coverageOption,
            employerContribution, cost, costPerOptions, costPerOption, additionalChronic, additionalMental, additionalMaternity, isOpenEnrollment,
            initialData, effectiveDate, riderLabels, tiers
        } = this.props;
        const localization = getLocalization(lang);
        const strings = localization.summary;
        const costPayment = !!costPerOptions && costPerOptions.filter((cpo) => cpo.id === costPerOption)[0].value;
        const selectedCoverageOption = coverageOptions.filter((co) => co.value === coverageOption);
        let displayTier = "";
        if (!!selectedCoverageOption && selectedCoverageOption.length > 0) {
            displayTier = getTranslatedCoverageText(selectedCoverageOption[0].value, localization);
        }

        let translatedCoverage = {};
        if(isBrellaChoice){
            translatedCoverage = this.translateSliderSelectionToAmount();
        } else {
            translatedCoverage.moderateCoverageSelected = moderateCoverageSelected;
            translatedCoverage.severeCoverageSelected = severeCoverageSelected;
            translatedCoverage.catastrophicCoverageSelected = catastrophicCoverageSelected;
        }

        const formattedCostPayment = costPayment === "Month" ? strings.mo : strings.paycheck.toLowerCase();
        let isPaperEnrollment = !!initialData.isPaperEnrollment;
        const {uiFlow} = initialData;
        const isStandalone = uiFlow === uiFlowStandalone;

        const riders = [
            { amount: additionalChronic, label: getChronicRiderLabel(strings, riderLabels) },
            { amount: additionalMental, label: getMentalRiderLabel(strings, riderLabels) },
            { amount: additionalMaternity, label: getMaternityRiderLabel(strings, riderLabels) },
        ].filter(({ amount }) => amount > 0);

        return (
            <React.Fragment>
                <Container className={'contentContainer'}>
                    <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>
                    <CustomGrid container stackable columns={1} centered className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`} fitted={'horizontally'}>
                        <CustomGrid.Column width={8}>
                            <Header as="h2">{strings.title}</Header>
                            <p>{strings.description}</p>

                            <PlanWarningsBanner />

                            <Segment style={{padding: '3em', marginBottom: '0', boxShadow: 'unset'}}>
                                <CustomGrid columns={2}>
                                    <CustomGrid.Column>
                                        <CustomGrid.Row>
                                            {(isAIG() || isRenaissance()) && isStandalone && hasTierSelected(tiers) &&
                                            <React.Fragment>
                                                <div className="small neutral600Text">
                                                    <b>{strings.selectOffering}</b>
                                                </div>
                                                <Table basic={'very'} className="summaryTableMarginTop">
                                                    <Table.Body>
                                                        <Table.Row>
                                                            <Table.Cell><b>{strings.planName}</b></Table.Cell>
                                                            <Table.Cell>{getTierName(tiers)}</Table.Cell>
                                                        </Table.Row>
                                                    </Table.Body>
                                                </Table>
                                            </React.Fragment>
                                            }
                                            <div className="small neutral600Text"><b>{strings.benefitAmounts}</b></div>
                                            <Table basic={'very'} className="summaryTableMarginTop">
                                                <Table.Body>
                                                    <Table.Row>
                                                        <Table.Cell><b>{strings.moderate}</b></Table.Cell>
                                                        <Table.Cell>${formatMoneyAmount(translatedCoverage.moderateCoverageSelected)}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell><b>{strings.severe}</b></Table.Cell>
                                                        <Table.Cell>${formatMoneyAmount(translatedCoverage.severeCoverageSelected)}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell><b>{strings.catastrophic}</b></Table.Cell>
                                                        <Table.Cell>${formatMoneyAmount(translatedCoverage.catastrophicCoverageSelected)}</Table.Cell>
                                                    </Table.Row>
                                                </Table.Body>
                                            </Table>

                                            {employerContribution > 0 && <React.Fragment>
                                                <div className="small neutral600Text" style={{marginBottom: '0.4em'}}>
                                                    <b>{strings.employerContrib}</b></div>
                                                <b>${employerContribution}</b>
                                            </React.Fragment>
                                            }

                                            <div style={{marginTop: '1em'}}>
                                                <div className="small neutral600Text" style={{marginBottom: '0.4em'}}>
                                                    <b>{strings.whosCovered}</b></div>
                                                <b>{displayTier}</b>
                                            </div>
                                        </CustomGrid.Row>
                                    </CustomGrid.Column>

                                    <CustomGrid.Column>
                                        <CustomGrid.Row>
                                            {riders.length > 0 &&
                                                <>
                                                    <div className="small neutral600Text"><b>{strings.additionalCoverage}</b></div>
                                                    <Table basic="very" style={{ marginTop: 0 }}>
                                                        <Table.Body>
                                                            {riders.map(({ amount, label }, index) => (
                                                                <Table.Row key={index}>
                                                                    <Table.Cell>
                                                                        <b>{label}</b>
                                                                    </Table.Cell>
                                                                    <Table.Cell>${amount}</Table.Cell>
                                                                </Table.Row>
                                                            ))}
                                                        </Table.Body>
                                                    </Table>
                                                </>
                                            }

                                            <div className="small neutral600Text" style={{marginBottom: '0.4em'}}>
                                                <b>{strings.effectiveDate}</b>
                                            </div>
                                            <b>{moment(effectiveDate).format("MMM DD, YYYY")}</b>

                                            <div style={{marginTop: '1em'}}>
                                                <div className="small neutral600Text" style={{marginBottom: '0.4em'}}>
                                                    <b>{strings.yourCost}</b>
                                                </div>
                                                <b>${formatMoneyAmount(cost)}/{formattedCostPayment}</b>
                                            </div>
                                        </CustomGrid.Row>
                                    </CustomGrid.Column>
                                </CustomGrid>
                            </Segment>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>

                {isOpenEnrollment || isPaperEnrollment ? (
                    <Footer
                        link = {<span><b>{strings.or}</b>
                                <ClickableText onClick={() => this.props.history.push(this.props.prevRoute)}>
                                    {' '}{strings.goBack}</ClickableText></span>}
                        showTopFooter={true} showCenterData={true}
                        buttonText={localization.next}
                        onClickCallback={() => this.props.history.push(this.props.nextRoute)}
                    />
                ) : (
                    <Footer showTopFooter={false} showCenterData={true}/>
                )}

            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(Summary));
